import React from "react";
import './style.scss';

import { Layout } from 'antd';
import R2Footer from "../../components/Footer";

const { Content } = Layout;

const Settings = () => {
    return (
        <Layout style={{ padding: '0 24px 24px' }}>
        <Content
            className="site-layout-background"
            style={{
                padding: 24,
                margin: '16px 0px',
                minHeight: 280,
            }}
        >
            Settings
            <br /><br />
            Coming soon
        </Content>
        <R2Footer />
    </Layout>
    )
}

export default Settings